module.exports = __webpack_public_path__ + "static/media/Plano3.9056aa31.jpg";